export { default } from './mergeClasses';